import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import { useDispatch, useSelector } from 'react-redux';
import { updateUserProfileApiCall } from '@/services/api'
import { updateProfileFields } from "@/store/slices/profile/profileSlice"
import { RootState } from '@/store/index';
import { useEffect, useState } from 'react';
import { setProfileStepNo } from "@/store/slices/profile/profileStepNo"

import LegalInfoView from './view'
export default function LegalInfo() {
    const { common } = useLocalTranslation();
    const dispatch = useDispatch()

    const profileDetails = useSelector((state: RootState) => state.profileReducer.profile);
    const profileStepNo = useSelector((state: RootState) => state.profileStepNoReducer.profileStepNo);

    const [isSubmitBtnLoading, setIsSubmitBtnLoading] = useState(false)
    const [errMsg, setErrMsg] = useState("")
    const [legalFirstName, setLegalFirstName] = useState("")
    const [legalMiddleName, setLegalMiddleName] = useState("")
    const [legalLastName, setLegalLastName] = useState("")
    const [legalInfoAcknowledged, setLegalInfoAcknowledged] = useState(false)

    useEffect(() => {
        updateBasicDetails()
    }, [profileDetails])

    const updateBasicDetails = () => {
        if (profileDetails.firstName) {
            setLegalFirstName(profileDetails.firstName)
        }
        if (profileDetails.middleName) {
            setLegalMiddleName(profileDetails.middleName)
        }
        if (profileDetails.lastName) {
            setLegalLastName(profileDetails.lastName)
        }
        if (profileDetails.legalInfoAcknowledged) {
            setLegalInfoAcknowledged(profileDetails.legalInfoAcknowledged)
        }
    }

    const handleInputChange = (e: any, source: string) => {
        setErrMsg('')
        const val = e.target.value
        if (source === "legalFirstName") {
            setLegalFirstName(val)
        } else if (source === "legalMiddleName") {
            setLegalMiddleName(val)
        } else if (source === "legalLastName") {
            setLegalLastName(val)
        }
    }

    const handleOnCheckBoxChanged = (e: any, source: string) => {
        const val = e.target.checked
        if (source === "legalInfoAcknowledged") {
            setLegalInfoAcknowledged(val)
        }
    }

    const handleSubmit = (source: string) => {
        setErrMsg('')
        setIsSubmitBtnLoading(true)
        if (legalFirstName !== "" && legalLastName !== "" && legalInfoAcknowledged) {
            const updatedFields = {
                firstName: legalFirstName,
                middleName: legalMiddleName,
                lastName: legalLastName,
                legalInfoAcknowledged:legalInfoAcknowledged
            }
            handleSubmit3(updatedFields)
        } else {
            if(legalFirstName === "" || legalLastName === "" ){
                setErrMsg(common.statusText.pleaseGiveInput3)
            } else {
                setErrMsg(common.statusText.pleaseGiveInput4)
            }
            setIsSubmitBtnLoading(false)
        }
    }


    const handleSubmit3 = async (updatedFields: any) => {
        const fieldsToUpdate: any = {};
        let anyFieldChanged = false;
        let anyValueEmpty = false
        for (const source in updatedFields) {
            if (Object.prototype.hasOwnProperty.call(updatedFields, source)) {
                const newValue = updatedFields[source];
                const currentValue = profileDetails[source];
                if (newValue === "") {
                    anyValueEmpty = true
                }
                if (newValue !== "" && newValue !== currentValue) {
                    fieldsToUpdate[source] = newValue;
                    anyFieldChanged = true;
                }
            }
        }

        if (Object.keys(fieldsToUpdate).length > 0) {
            const updateUserProfileApiCallStatus = await updateUserProfileApiCall(fieldsToUpdate);

            if (updateUserProfileApiCallStatus.status) {
                dispatch(setProfileStepNo(profileStepNo + 1));
                dispatch(updateProfileFields(fieldsToUpdate));
            } else {
                setErrMsg(common.statusText.issueInUpdating);
            }
        } else {
            if (anyValueEmpty) {
                setErrMsg(common.statusText.pleaseGiveInput2);
            }

            dispatch(setProfileStepNo(profileStepNo + 1));
        }

        setIsSubmitBtnLoading(false);
    };

    return (
        <>
            <LegalInfoView
                errMsg={errMsg}
                legalFirstName={legalFirstName}
                legalMiddleName={legalMiddleName}
                legalLastName={legalLastName}
                legalInfoAcknowledged={legalInfoAcknowledged}
                isSubmitBtnLoading={isSubmitBtnLoading}
                handleInputChange={handleInputChange}
                handleOnCheckBoxChanged={handleOnCheckBoxChanged}
                handleSubmit={handleSubmit}
            />
        </>
    );
}
